<template>
    <div style="height: 100%;display: flex;flex-direction: column;">
        <div style="height: 128px;background: #fff;padding:38px 16px 0">
            <div>
                <span style="color:rgba(44, 54, 74, 1);font-size:20px;font-weight: bold;">小文短信服务发送记录</span>
                <span @click="loginOut" style="display: inline-block;width: 56px;height: 28px;display: inline-block;background: rgba(243, 245, 248, 1);color:rgba(158, 172, 196, 1);font-size: 14px;text-align: center;line-height: 28px;border-radius: 6px;float: right;margin-top:4px;">退出</span>
            </div>
            <div style="margin-top:23px;">
                <span style="color:rgba(103, 110, 125, 1);font-size:13px;">条件筛选</span>
                <a-dropdown :trigger="['click']">
                    <span style="display: inline-block;width:56px;height:32px;text-align: center;line-height: 32px;color:#fff;border-radius: 6px;font-size: 14px;background: rgba(66, 223, 228, 1);color:#fff;margin-left:24px;">导出</span>
                    <a-menu slot="overlay">
                        <a-menu-item key="1" @click="downLoadAll">
                            下载全部
                        </a-menu-item>
                        <a-menu-item key="3" @click="goDownload">
                            导出记录
                        </a-menu-item>
                    </a-menu>
                </a-dropdown>
                <span @click="goFilter" style="display: inline-block;width:56px;height:32px;text-align: center;line-height: 32px;color:#fff;border-radius: 6px;font-size: 14px;background: rgba(66, 223, 228, 1);color:#fff;margin-left:24px;">清洗</span>
                <div style="float: right;position: relative;">
                    <img @click="showFilter" src="../../assets/img/filter.png" style="width: 19px;" alt="">
                    <span v-if="filterCount!=0" style="position: absolute;display: inline-block;width: 14px;height: 14px;border-radius: 7px;text-align: center;line-height: 14px;color:#fff;background:rgba(66, 223, 228, 1);right:-5px;top:-5px;font-size: 12px;">{{ filterCount }}</span>
                </div>
            </div>
        </div>
        <div ref="scrollWrap" @scroll.passive="handleScroll" style="flex: 1;overflow-y: auto;background: #F9F9F9;position: relative;padding-bottom: 100px;">
            <div style="padding:0 16px">
                <div v-for="(item,index) in sendMsgRecord" :key="index" style="height: 82px;border-radius: 8px;background: #fff;padding: 12px 16px;margin-top:16px;">
                    <div style="display: flex;">
                        <div style="flex:1;height: 32px;background: rgba(243, 245, 248, 1);border-radius: 16px;line-height: 32px;padding:0 12px">
                            <span style="color:rgba(44, 54, 74, 1);font-size: 15px;font-weight: bold;">{{item.phone}}</span>
                            <span style="float: right;color:rgba(158, 172, 196, 1);font-size: 13px;;">模板 ID：{{ item.fengxinTemplateId }}  </span>
                        </div>
                        <span style="display: inline-block;width: 80px;text-align: right;height: 32px;line-height: 32px;font-size: 15px;">{{item.status}}</span>
                    </div>
                    <div style="margin-top:8px;">
                        <span style="color:rgba(103, 110, 125, 1);font-size: 12px;;">计费条数：{{ item.chargeCount }}</span>
                        <span style="color:rgba(179, 184, 193, 1);font-size: 12px;float: right;margin-top:3px;;">{{item.sendTime}}</span>
                    </div>
                </div>
                <div style="text-align:center;padding:16px;color:#999">
                    <!-- <span v-if="loading">加载中...</span> -->
                    <span v-if="total==sendMsgRecord.length&&total!=0">没有更多了</span>
                </div>
            </div>
            <div v-if="sendMsgRecord.length==0" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);">
                <div style="text-align: center;">
                    <img src="../../assets/img/no-data.png" style="width:56px;" alt="">
                </div>
                <div style="text-align: center;color:rgba(179, 184, 193, 1);font-size: 12px;margin-top:8px;;">暂无数据</div>
            </div>
        </div>
        <div style="position: fixed;height: 60px;width:100%;left:0;bottom:24px;padding:0 16px;z-index: 100;">
            <div @click="goSendMsg" style="width:100%;height: 60px;border-radius: 30px;box-shadow: 0px 5px 28px 0px rgba(44, 54, 74, 0.16);text-align: center;line-height: 60px;background: #fff;;">
                <img src="../../assets/img/message.svg" style="width: 24px;margin-right: 10px;;" alt="">
                <span style="color:rgba(44, 54, 74, 1);font-size: 15px;font-weight: bold;">短信发送</span>
            </div>
        </div>
        <transition name="fade">
            <div class="filter-modal" v-show="filterModal" @click="filterModal = false">
                <transition name="slide-up">
                    <div
                        class="task-panel"
                        v-if="filterModal"
                        @click.stop
                    >
                        <div @click.stop style="height: 532px;position: fixed;left: 0;bottom: 0;border-radius: 24px 24px 0 0;box-shadow: 0px -9px 56px 0px rgba(44, 54, 74, 0.24);width: 100%;z-index: 10000;background: #fff;padding: 16px 20px 24px;">
                            <div style="text-align: center;">
                                <span @click="resetCondition" style="color:rgba(66, 223, 228, 1);font-size: 14px;color:rgba(66, 223, 228, 1);float: left;margin-top:2px;">重置</span>
                                <span style="color:rgba(44, 54, 74, 1);font-size: 16px;font-weight: bold;">筛选条件</span>
                                <img @click="filterModal = false" src="../../assets/img/close.svg" style="width:24px;float: right;" alt="">
                            </div>
                            <div style="color:rgba(103, 110, 125, 1);font-size: 13px;margin-top:20px;">号码</div>
                            <div style="margin-top:12px;">
                                <a-input v-model="phoneNum" style="height: 40px;border-radius: 4px;border: 1px solid rgba(179, 184, 193, 0.5);" placeholder="请输入" />
                            </div>
                            <div style="color:rgba(103, 110, 125, 1);font-size: 13px;margin-top:20px;">发送时间</div>
                            <div style="margin-top:12px;">
                                <a-range-picker v-model="timeData" :show-time="showTime" format="YYYY-MM-DD HH:mm:ss" :disabled-date="disabledDate"  />
                            </div>
                            <div style="color:rgba(103, 110, 125, 1);font-size: 13px;margin-top:20px;">发送状态</div>
                            <div style="margin-top:12px;">
                                <a-select placeholder="请选择" style="width: 100%;" v-model="sendState">
                                    <a-select-option value="">
                                        全部
                                    </a-select-option>
                                    <a-select-option value="1">
                                        待发送
                                    </a-select-option>
                                    <a-select-option value="2">
                                        发送中
                                    </a-select-option>
                                    <a-select-option value="3">
                                        发送成功
                                    </a-select-option>
                                    <a-select-option value="4">
                                        发送失败
                                    </a-select-option>
                                </a-select>
                            </div>
                            <div style="color:rgba(103, 110, 125, 1);font-size: 13px;margin-top:20px;">短信模版</div>
                            <div style="margin-top:12px">
                                <div class="mine-share">
                                    <span @click="selectType(1)" :class="{'active':currentType==1}">我的</span>
                                    <span @click="selectType(2)" :class="{'active':currentType==2}">共享</span>
                                </div>
                            </div>
                            <div style="margin-top:12px;">
                                <a-select placeholder="请选择" style="width: 100%;" v-model="msgSupport">
                                    <a-select-option :value="item.id" v-for="(item,index) in magTplList" :key='index'>
                                        <div v-html="item.templateContent"></div>
                                    </a-select-option>
                                </a-select>
                            </div>
                            <div @click="queryBasicData(1)" style="margin-top:24px;height: 40px;background: rgba(66, 223, 228, 1);text-align: center;line-height: 40px;color:#fff;border-radius: 8px;font-size: 15px;">确认</div>
                        </div>
                    </div>
                </transition>
            </div>
        </transition>
        <transition name="fade">
            <div class="task-modal" v-show="taskModal" @click="taskModal = false">
                <transition name="slide-up">
                    <div
                        class="task-panel"
                        v-if="taskModal"
                        @click.stop
                    >
                        <div @click.stop style="height: 492px;position: fixed;left: 0;bottom: 0;border-radius: 24px 24px 0 0;box-shadow: 0px -9px 56px 0px rgba(44, 54, 74, 0.24);width: 100%;z-index: 10000;background: #fff;padding: 16px 20px 24px;">
                            <div style="text-align: center;">
                                <span style="color:rgba(44, 54, 74, 1);font-size: 16px;font-weight: bold;">创建短信导出任务</span>
                                <img @click="taskModal = false" src="../../assets/img/close.svg" style="width:24px;float: right;" alt="">
                            </div>
                            <div style="margin-top:20px">
                                <a-icon style="color:rgba(255, 170, 0, 1);font-size: 18px;" type="exclamation-circle" />
                                <span style="color:rgba(0, 0, 0, 1);font-size: 16px;font-weight: bold;margin-left:8px;">请确认导出内容</span>
                            </div>
                            <div style="margin-top:20px;color:rgba(103, 110, 125, 1);font-size:13px;">导出数据数量：</div>
                            <div style="color:rgba(18, 18, 18, 1);font-size:20px;margin-top:8px">{{total}}条</div>
                            <div style="margin-top:20px;color:rgba(103, 110, 125, 1);font-size:13px;">开始时间：</div>
                            <div style="color:rgba(18, 18, 18, 1);font-size:20px;margin-top:8px">{{startTime}}</div>
                            <div style="margin-top:20px;color:rgba(103, 110, 125, 1);font-size:13px;">结束时间：</div>
                            <div style="color:rgba(18, 18, 18, 1);font-size:20px;margin-top:8px">{{endTime}}</div>
                            <div style="margin-top:20px;color:rgba(103, 110, 125, 1);font-size:13px;">描述(选填)：</div>
                            <div style="margin-top:8px;">
                                <a-textarea v-model="outputDes" placeholder="请输入" style="height: 40px;" />
                            </div>
                            <div @click="sureMsgBool" style="margin-top:24px;height: 40px;background: rgba(66, 223, 228, 1);text-align: center;line-height: 40px;color:#fff;border-radius: 8px;font-size: 15px;">确认</div>
                        </div>
                    </div>
                </transition>
            </div>
        </transition>
    </div>
</template>
  
<script>
    import moment from 'moment'
    export default {
        name: 'MobileRecord',
        props: {
            msg: String
        },
        data() {
            const start = moment().startOf('day')      // 当日 00:00:00
            const end   = moment().endOf('day')        // 当日 23:59:59
            return {
                filterModal: false,
                phoneNum: '',
                timeData: [start, end],
                showTime: {
                    defaultValue: [
                        moment('00:00:00', 'HH:mm:ss'),
                        moment('23:59:59', 'HH:mm:ss')
                    ]
                },
                sendState: undefined,
                msgSupport: undefined,
                magTplList: [],
                msgTplSign: 1,
                total: 0,
                currentPage: 1,
                pageSize: 10,
                sendMsgRecord: [],
                chargeCountSum: 0,
                // filterCount: 0,
                initData: {
                    phoneNum: '',
                    sendState: undefined,
                    msgSupport: undefined
                },
                taskModal: false,
                currentType: 1,
                startTime: '',
                endTime: '',
                outputDes: '',
                loading: false,
                finished: false
            } 
        },
        computed: {
            filterCount() {
                let count = 0
                if (this.phoneNum !== this.initData.phoneNum) count++
                if (this.sendState !== this.initData.sendState) count++
                if (this.msgSupport !== this.initData.msgSupport) count++
                return count
            }
        },
        methods: {
            moment,
            queryBasicData(num) {
                this.filterModal = false
                if(this.timeData != null){
                    this.startTime = moment(this.timeData[0], 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
                    this.endTime = moment(this.timeData[1], 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
                }
                if(num == 1){
                    this.currentPage = 1
                }
                this.axios(
                    {
                    method:'get',
                    url:'/api/smsRecord/list', 
                    params: {
                        current: this.currentPage,
                        size: 10,
                        phone: this.phoneNum,
                        startTime: this.startTime,
                        endTime: this.endTime,
                        sendStatus: this.sendState,
                        smsTemplateId: this.msgSupport,
                    }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.total = response.data.data.total
                        if(num == 1){
                            this.sendMsgRecord = response.data.data.records
                        }else{
                            this.sendMsgRecord = this.sendMsgRecord.concat(response.data.data.records)
                        }
                        console.log("当前num="+num)
                        console.log(this.sendMsgRecord.length)
                        console.log(this.total)
                        console.log(this.sendMsgRecord)
                        if (this.sendMsgRecord.length == this.total) {
                            this.finished = true
                        }else{
                            this.finished = false
                        }
                        this.loading = false
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
                if(num == 1){
                    this.axios(
                    {
                        method:'get',
                        url:'/api/smsRecord/allChargeCount', 
                        params: {
                        phone: this.phoneNum,
                        startTime: this.startTime,
                        endTime: this.endTime,
                        sendStatus: this.sendState,
                        smsTemplateId: this.msgSupport,
                        }
                    }
                    )
                    .then(response=> {
                    if(response.data.code == 0){
                        this.chargeCountSum = response.data.data.allChargeCount
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                    })
                    .catch(error=> {
                        console.log(error)
                    })
                }
            },
            showFilter() {
                this.filterModal = true
            },
            disabledDate(current) {
                if (!this.timeData || this.timeData.length === 0) {
                    return false
                }

                const [start] = this.timeData
                if (!start) return false

                // 超过 31 天不可选
                return Math.abs(current.diff(start, 'days')) >= 31
            },
            queryMsgTpl() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/templateManagement/selectList', 
                        params: {
                            shareStatus: this.msgTplSign,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        // console.log(response.data.data)
                        this.magTplList = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            resetCondition() {
                const start = moment().startOf('day')      // 当日 00:00:00
                const end   = moment().endOf('day')        // 当日 23:59:59
                this.phoneNum = ''
                this.timeData = [start, end]
                this.sendState = undefined
                this.msgSupport = undefined
                this.queryBasicData(1)
            },
            loginOut() {
                this.$router.push("/Login")
            },
            downLoadAll() {
                if(this.total == 0){
                    this.$message.warning('当前暂无需要导出数据')
                }else{
                    this.taskModal = true
                }
            },
            goDownload() {
                this.$router.push("/MobileDownload")
            },
            goSendMsg() {
                this.$router.push("/MobileSend")
            },
            selectType(type) {
                this.currentType = type
            },
            sureMsgBool() {
                this.taskModal = false
                let startTime = '', endTime = ''
                if(this.timeData != null){
                    startTime = moment(this.timeData[0], 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
                    endTime = moment(this.timeData[1], 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
                }
                this.axios.post('/api/smsRecord/export',{
                    phone: this.phoneNum,
                    startTime: startTime,
                    endTime: endTime,
                    sendStatus: this.sendState,
                    smsTemplateId: this.msgSupport,
                    desc: this.outputDes
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('导出成功')
                    }else if(response.data.code == 'A0002'){
                        this.$message.warning('导出数据已超过最大限度')
                    }else{
                        this.$message.error(response.data.userTip)
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            loadData() {
                if (this.loading || this.finished) return
                this.loading = true
                this.currentPage = this.currentPage + 1
                this.queryBasicData(2)
            },
            handleScroll () {
                console.log("执行滚动")
                console.log(this.loading)
                console.log(this.finished)
                if (this.loading || this.finished) return

                const el = this.$refs.scrollWrap
                if (!el) return

                const scrollBottom = el.scrollHeight - el.scrollTop - el.clientHeight
                console.log('距离底部距离为'+scrollBottom)
                // ✅ 距离底部 50px 触发
                if (scrollBottom < 50) {
                    this.loadData()
                }
            },
            goFilter() {
                this.$router.push("/MobileFilter")
            }
        },
        mounted: function() {
            this.queryMsgTpl()
            this.queryBasicData(1)
        }
    }
</script>

<style scoped lang="less">
    .filter-modal{
        // position: fixed;
        // left: 0;
        // top: 0;
        // width: 100%;
        // height: 100%;
        // z-index: 1000;
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.55);
        z-index: 1000;
    }
    /deep/ .slide-up-enter-active,
    /deep/ .slide-up-leave-active {
        transition: transform 0.3s ease-out;
    }

    /deep/ .slide-up-enter,
    /deep/ .slide-up-leave-to {
        transform: translateY(100%);
    }

    /deep/ .slide-up-enter-to,
    /deep/ .slide-up-leave {
        transform: translateY(0);
    }

    .task-modal {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.55);
        z-index: 1000;
    }

    .task-panel {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 492px;
        background: #fff;
        border-radius: 24px 24px 0 0;
    }

    ::v-deep .ant-calendar-picker-input{
        height: 40px;
        border: 1px solid rgba(121, 136, 155, 0.3);
        border-radius: 5px;
    }
    ::v-deep .ant-select-selection--single{
        height: 40px;
        border: 1px solid rgba(121, 136, 155, 0.3);
        border-radius: 5px;
    }
    ::v-deep .ant-select-selection--single .ant-select-selection__rendered{
        height: 40px;
    }
    ::v-deep .ant-select-selection-selected-value{
        line-height: 40px;
    }
    .mine-share{
        display: inline-block;
        width: 126px;
        height:28px;
        background: #E8E9EC;
        border-radius: 8px;
        padding: 3px;
        span{
            display: inline-block;
            height: 22px;
            line-height: 22px;
            width: 60px;
            text-align: center;
            color: rgba(103, 110, 125, 1);
            font-size: 12px;
        }
        span.active{
            background: #fff;
            border-radius: 6px;
            color: rgba(44, 54, 74, 1);
            font-size: 12px;
            font-weight: bold;
        }
    }
</style>
  